import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { IHelpGuideSummary } from '@apis/help';
import styles from './GuideReaderPage.module.css';

interface IGuideFooterProps {
  family: { parent: IHelpGuideSummary; siblings: IHelpGuideSummary[]; index: number } | null;
}

export function GuideFooter({ family }: IGuideFooterProps) {
  const { t } = useTranslation();
  if (!family) return null;
  const previous = family.index > 0 ? family.siblings[family.index - 1] : null;
  const next = family.siblings[family.index + 1];
  return (
    <div className={styles.pager}>
      {previous ? (
        <Link to={`/help/${previous.slug}`}><small>{t('help.previousReport')}</small>{previous.title}</Link>
      ) : (
        <Link to={`/help/${family.parent.slug}`}><small>{t('help.backTo')}</small>{t('help.hub', { title: family.parent.title })}</Link>
      )}
      {next ? <Link className={styles.next} to={`/help/${next.slug}`}><small>{t('help.nextReport')}</small>{next.title}</Link> : <span />}
    </div>
  );
}
